module.exports = __webpack_public_path__ + "img/adatvedelem.8cd9ff58.png";